import { useEffect, useState } from "react";
import "../css/SuppliersPanel.css";
import "../css/BulkEdit.css";
import PopupMessage from "./PopupMessage";
import DataTable from "react-data-table-component";
import CheckBox from "./CheckBox";
import InputData from "./InputData";
import Dropdown from "./Dropdown";
import ButtonIconH from "./ButtonIconH";
import {
  opticColumns,
  hearingAidsColumnsStoreBulkEdit,
  lensesFamilyStoreBulkEdit,
  contactLensesColumnsStoreBulkEdit,
  liquidColumnsStoreBulkEdit,
  frameColumnsStoreBulkEdit,
  variousColumnsStoreBulkEdit,
  sunglassesColumnsStoreBulkEdit,
} from "../js/tableColumns";
import {
  formatValueUnit,
  inputOnEnter,
  selectedOptic,
  userData,
} from "../js/utils";
import { useSuppliers } from "../hooks/useSuppliers";
import { post } from "../js/post";
import { useOptics } from "../hooks/useOptics";
import moment from "moment";

export default function BulkEdit({ productFamily, products, onClose }) {
  const [supplierList] = useSuppliers(productFamily, "");
  const [selectedSupplier, setSelectedSupplier] = useState({
    id: "",
    text: "",
  });
  const [productList, setProductList] = useState([]);
  const [popupQuestion, setPopupQuestion] = useState(null);
  const [selectedItems, setSelectedItems] = useState(products);
  const [toggleOptions, setToggleOptions] = useState({
    newBrand: false,
    minStock: false,
    zeroStock: false,
    saleComission: false,
    deadlineDate: false,
    maxDiscount: false,
    valuePVP: false,
    activeOffer: false,
  });
  const [inputs, setInputs] = useState({
    newBrand: "",
    minStock: "",
    saleComission: "",
    deadlineDate: "",
    maxDiscount: "",
    valuePVP: "",
    activateOfferDateFrom: "",
    activateOfferDateTo: "",
    activateOfferValue: "",
  });
  const [actionPVP, setActionPVP] = useState("");
  const [actionActivationOffer, setActionActivationOffer] = useState("");
  const opticList = useOptics();
  const [selectedOptics, setSelectedOptics] = useState([]);

  // console.log("productFamily: ", productFamily);
  // console.log("products: ", products);
  // console.log("productList: ", productList);
  // console.log("selectedItems: ", selectedItems);
  // console.log("supplierList: ", supplierList);
  // console.log("selectedSupplier: ", selectedSupplier);

  const handleInputChange = (name, value) => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  function selectProductFamilyColumns() {
    const columns = {
      0: hearingAidsColumnsStoreBulkEdit,
      1: lensesFamilyStoreBulkEdit,
      2: contactLensesColumnsStoreBulkEdit,
      3: liquidColumnsStoreBulkEdit,
      4: frameColumnsStoreBulkEdit,
      5: variousColumnsStoreBulkEdit,
      6: sunglassesColumnsStoreBulkEdit,
    };
    const columnsWithCheck = columns[productFamily].map((col) => {
      if (col.name === "") {
        return {
          ...col,
          selector: (row) => (
            <CheckBox
              active={selectedItems.some((e) => e.id === row.id)}
              onClick={() => handleCheckboxChange(row)}
            />
          ),
        };
      }

      return col;
    });
    return columnsWithCheck;
  }

  const updatedOpticColumns = opticColumns.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        selector: (row) => (
          <CheckBox
            active={selectedOptics.some((e) => e.id === row.id)}
            onClick={() => handleCheckboxChangeOptic(row)}
          />
        ),
      };
    }

    return col;
  });

  const createPopupQuestion = (
    text,
    onClickAccept,
    onClickCancel,
    textAccept,
    textCancel,
  ) => {
    setPopupQuestion({
      text,
      onClickCancel,
      onClickAccept,
      textAccept,
      textCancel,
    });
  };

  const removePopupQuestion = () => {
    setPopupQuestion(null);
  };

  function handleCheckboxChange(product) {
    setSelectedItems((prevSelected) =>
      prevSelected.some((e) => e.id === product.id)
        ? prevSelected.filter((element) => element.id !== product.id)
        : [...prevSelected, product],
    );
  }

  function handleSelectAll() {
    setSelectedItems((prev) => {
      const toAdd = productList.filter((e) => !prev.some((el) => el.id === e.id));
      return toAdd.length === 0 ? prev : [...prev, ...toAdd];
    });
  }

  function handleCleanSelected() {
    setSelectedItems([]);
  }

  function handleCheckboxChangeOptic(optic) {
    setSelectedOptics((prevSelected) =>
      prevSelected.some((e) => e.id === optic.id)
        ? prevSelected.filter((element) => element.id !== optic.id)
        : [...prevSelected, optic],
    );
  }

  function handleSelectAllOptic() {
    setSelectedOptics((prev) => {
      const toAdd = opticList.filter((e) => !prev.some((el) => el.id === e.id));
      return toAdd.length === 0 ? prev : [...prev, ...toAdd];
    });
  }

  function showSuccessfulEditingMessage() {
    createPopupQuestion(
      `La edición se ha realizado de forma correcta.`,
      removePopupQuestion,
      null,
      "Entendido",
    );
  }

  function handleCleanSelectedOptic() {
    setSelectedOptics([]);
  }

  const toggleTabIndex = {
    newBrand: 50,
    minStock: 51,
    zeroStock: null,
    saleComission: 52,
    deadlineDate: 56,
    maxDiscount: 53,
    valuePVP: 54,
    activeOffer: 57,
  };

  const toggleOrder = [
    "newBrand",
    "minStock",
    "zeroStock",
    "saleComission",
    "maxDiscount",
    "valuePVP",
    "deadlineDate",
    "activeOffer",
  ];

  function handleToggle(key) {
    const isActivating = !toggleOptions[key];
    const newOptions = { ...toggleOptions, [key]: isActivating };
    setToggleOptions(newOptions);

    if (isActivating) {
      const tabIdx = toggleTabIndex[key];
      if (tabIdx)
        setTimeout(
          () => document.querySelector(`[tabindex="${tabIdx}"]`)?.focus(),
          0,
        );
    } else {
      const currentIndex = toggleOrder.indexOf(key);
      const searchOrder = [
        ...toggleOrder.slice(currentIndex + 1),
        ...toggleOrder.slice(0, currentIndex),
      ];
      const nextActive = searchOrder.find(
        (k) => newOptions[k] && toggleTabIndex[k],
      );
      if (nextActive)
        setTimeout(
          () =>
            document
              .querySelector(`[tabindex="${toggleTabIndex[nextActive]}"]`)
              ?.focus(),
          0,
        );
    }
  }

  async function handleBulkEdition() {
    const tasks = [
      toggleOptions.newBrand && handleNewBrand(),
      toggleOptions.minStock && handleMinStock(),
      toggleOptions.zeroStock && handleZeroStock(),
      toggleOptions.saleComission && handleSaleComission(),
      toggleOptions.deadlineDate && handleDeadlineDate(),
      toggleOptions.maxDiscount && handleMaxDiscount(),
      toggleOptions.valuePVP && handlePVP(),
      toggleOptions.activeOffer && handleActivateOffer(),
    ].filter(Boolean);

    if (tasks.length === 0) return;
    await Promise.all(tasks);
    showSuccessfulEditingMessage();
  }

  async function handleNewSupplier() {
    if (selectedItems.length === 0 || !selectedSupplier.id) return;
    const selectedItemsIds = selectedItems.map((e) => e.codigo);
    await post(
      "support-extra/edicionMasivaProductos/EditarProveedorMasivo.php",
      {
        token: userData.token,
        idProveedor: selectedSupplier.id,
        familia: productFamily,
        codigos: selectedItemsIds,
      },
    );
    // console.log("EDITANDO PROVEEDOR: ", {
      // token: userData.token,
      // idProveedor: selectedSupplier.id,
      // familia: productFamily,
      // codigos: selectedItemsIds,
    // });
  }

  async function handleNewBrand() {
    if (selectedItems.length > 0 && inputs.newBrand !== "") {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      await post("support-extra/edicionMasivaProductos/EditarMarcaMasivo.php", {
        token: userData.token,
        marcaNueva: inputs.newBrand,
        familia: productFamily,
        codigos: selectedItemsIds,
      });
      // console.log("EDITANDO MARCA: ", {
        // token: userData.token,
        // marcaNueva: inputs.newBrand,
        // familia: productFamily,
        // codigos: selectedItemsIds,
      // });
    }
  }

  async function handleMinStock() {
    if (
      selectedItems.length > 0 &&
      selectedOptics.length > 0 &&
      inputs.minStock !== ""
    ) {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      const selectedOpticsIds = selectedOptics.map((e) => e.id);
      await post(
        "support-extra/edicionMasivaProductos/EditarStockMinimoMasivo.php",
        {
          token: userData.token,
          stock: inputs.minStock,
          codigos: selectedItemsIds,
          opticas: selectedOpticsIds,
        },
      );
      // console.log("EDITANDO STOCK MÍNIMO: ", {
        // token: userData.token,
        // stock: inputs.minStock,
        // codigos: selectedItemsIds,
        // opticas: selectedOpticsIds,
      // });
    }
  }

  async function handleZeroStock() {
    if (selectedItems.length > 0 && selectedOptics.length > 0) {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      const selectedOpticsIds = selectedOptics.map((e) => e.id);
      await post(
        "support-extra/edicionMasivaProductos/EditarStockCeroMasivo.php",
        {
          token: userData.token,
          codigos: selectedItemsIds,
          opticas: selectedOpticsIds,
        },
      );
      // console.log("EDITANDO STOCK A CERO: ", {
        // token: userData.token,
        // codigos: selectedItemsIds,
        // opticas: selectedOpticsIds,
      // });
    }
  }

  async function handleSaleComission() {
    if (
      selectedItems.length > 0 &&
      selectedOptics.length > 0 &&
      inputs.saleComission !== ""
    ) {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      const selectedOpticsIds = selectedOptics.map((e) => e.id);
      await post(
        "support-extra/edicionMasivaProductos/EditarComisionMasivo.php",
        {
          token: userData.token,
          comision: inputs.saleComission,
          codigos: selectedItemsIds,
          opticas: selectedOpticsIds,
        },
      );
      // console.log("EDITANDO COMISIÓN DE VENTAS: ", {
        // token: userData.token,
        // comision: inputs.saleComission,
        // codigos: selectedItemsIds,
        // opticas: selectedOpticsIds,
      // });
    }
  }

  async function handleDeadlineDate() {
    if (
      selectedItems.length > 0 &&
      selectedOptics.length > 0 &&
      inputs.deadlineDate !== ""
    ) {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      const selectedOpticsIds = selectedOptics.map((e) => e.id);
      await post(
        "support-extra/edicionMasivaProductos/EditarFechaLimiteMasivo.php",
        {
          token: userData.token,
          fechaLimite: inputs.deadlineDate,
          codigos: selectedItemsIds,
          opticas: selectedOpticsIds,
        },
      );
      // console.log("EDITANDO FECHA LÍMITE: ", {
        // token: userData.token,
        // fechaLimite: inputs.deadlineDate,
        // codigos: selectedItemsIds,
        // opticas: selectedOpticsIds,
      // });
    }
  }

  async function handleMaxDiscount() {
    if (
      selectedItems.length > 0 &&
      selectedOptics.length > 0 &&
      inputs.maxDiscount !== ""
    ) {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      const selectedOpticsIds = selectedOptics.map((e) => e.id);
      await post(
        "support-extra/edicionMasivaProductos/EditarDTOMaximoMasivo.php",
        {
          token: userData.token,
          dtoMaximo: inputs.maxDiscount,
          codigos: selectedItemsIds,
          opticas: selectedOpticsIds,
        },
      );
      // console.log("EDITANDO DESCUENTO MÁXIMO: ", {
        // token: userData.token,
        // dtoMaximo: inputs.maxDiscount,
        // codigos: selectedItemsIds,
        // opticas: selectedOpticsIds,
      // });
    }
  }

  async function handlePVP() {
    if (
      selectedItems.length > 0 &&
      selectedOptics.length > 0 &&
      inputs.valuePVP !== "" &&
      actionPVP !== ""
    ) {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      const selectedOpticsIds = selectedOptics.map((e) => e.id);
      await post("support-extra/edicionMasivaProductos/EditarPVPMasivo.php", {
        token: userData.token,
        tipoEdicion: actionPVP,
        cantidad: inputs.valuePVP,
        codigos: selectedItemsIds,
        opticas: selectedOpticsIds,
      });
      // console.log("EDITANDO PVP: ", {
        // token: userData.token,
        // tipoEdicion: actionPVP,
        // cantidad: inputs.valuePVP,
        // codigos: selectedItemsIds,
        // opticas: selectedOpticsIds,
      // });
    }
  }

  async function handleActivateOffer() {
    if (
      selectedItems.length > 0 &&
      selectedOptics.length > 0 &&
      inputs.activateOfferValue !== "" &&
      actionActivationOffer !== "" &&
      inputs.activateOfferDateFrom !== "" &&
      inputs.activateOfferDateTo !== ""
    ) {
      const selectedItemsIds = selectedItems.map((e) => e.codigo);
      const selectedOpticsIds = selectedOptics.map((e) => e.id);
      await post(
        "support-extra/edicionMasivaProductos/ActivarOfertaMasivo.php",
        {
          token: userData.token,
          fechaDesde: inputs.activateOfferDateFrom,
          fechaHasta: inputs.activateOfferDateTo,
          tipoOferta: actionActivationOffer,
          cantidad: inputs.activateOfferValue,
          codigos: selectedItemsIds,
          opticas: selectedOpticsIds,
        },
      );
      // console.log("EDITANDO OFERTA ACTIVA: ", {
        // token: userData.token,
        // fechaDesde: inputs.activateOfferDateFrom,
        // fechaHasta: inputs.activateOfferDateTo,
        // tipoOferta: actionActivationOffer,
        // cantidad: inputs.activateOfferValue,
        // codigos: selectedItemsIds,
        // opticas: selectedOpticsIds,
      // });
    }
  }

  async function getUpdatedProducts() {
    const selectedItemCodes = selectedItems.map((e) => e.codigo);
    const response = await post(
      "support-extra/edicionMasivaProductos/ListarProductosSeleccionadosMasivo.php",
      {
        token: userData.token,
        familia: productFamily,
        idOptica: selectedOptic.id,
        codigos: selectedItemCodes,
      },
    );
    // console.log(
      // "OBTENIENDO PRODUCTOS SELECCIONADOS MASIVO: ",
      // {
        // token: userData.token,
        // familia: productFamily,
        // idOptica: selectedOptic.id,
        // codigos: selectedItemCodes,
      // },
      // response,
    // );
    setProductList((prev) =>
      prev.map((item) => {
        const updated = response.productos.find(
          (r) => r.codigo === item.codigo,
        );
        return updated ? updated : item;
      }),
    );
  }

  useEffect(() => {
    setProductList(products);
    setSelectedItems((prev) => {
      const filtered = prev.filter((item) => products.some((p) => p.id === item.id));
      return filtered.length === prev.length ? prev : filtered;
    });
  }, [products]);

  useEffect(() => {
    getUpdatedProducts();
  }, [selectedItems]);

  return (
    <div className="external-window-bg">
      {popupQuestion && (
        <PopupMessage
          text={popupQuestion.text}
          onClickCancel={popupQuestion.onClickCancel}
          onClickAccept={popupQuestion.onClickAccept}
          textAccept={popupQuestion.textAccept}
          textCancel={popupQuestion.textCancel}
        ></PopupMessage>
      )}
      <div className="external-window external-window-suppliers">
        <div className="external-window-header">
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              onClose(productList);
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
          <span className="popup-screen-header-title">Edición masiva</span>
        </div>
        <div className="section-full-secs" style={{ gap: 10 }}>
          <div
            className="section-content-info"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              gap: "40px",
            }}
          >
            <div className="flex-col-gap">
              <div className="opt-table-content grid-4" id="bulk-edit-grid">
                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Nuevo proveedor</span>
                </div>
                <div className="cell cell-start-content">Proveedor</div>
                <div className="cell combined-cells-3">
                  <Dropdown
                    tabIndex={54}
                    optionList={supplierList.map((e) => ({
                      id: e.id,
                      text: e.nombre,
                    }))}
                    size={0}
                    op={selectedSupplier.id}
                    mandatory={true}
                    onChange={(e) => {
                      setSelectedSupplier(e);
                    }}
                  ></Dropdown>
                </div>
                <div
                  className="cell combined-cells-4"
                  style={{ marginTop: 10 }}
                >
                  <ButtonIconH
                    text="Aplicar"
                    small={true}
                    disabled={selectedSupplier.id === ""}
                    onClick={async () => {
                      await handleNewSupplier();
                      await getUpdatedProducts();
                      showSuccessfulEditingMessage();
                    }}
                  ></ButtonIconH>
                </div>
                <div className="combined-cells-4"></div>
                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Nueva marca</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("newBrand")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.newBrand}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">Marca</div>
                <div className="cell combined-cells-3">
                  <InputData
                    tabIndex={50}
                    inactive={!toggleOptions.newBrand}
                    type="type-alphanum-ext"
                    size={0}
                    input={inputs.newBrand}
                    onChange={(e) => {
                      handleInputChange("newBrand", e);
                    }}
                  ></InputData>
                </div>
                <div className="combined-cells-4"></div>
                <div className="combined-cells-4"></div>
                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Stock mínimo</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("minStock")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.minStock}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">Stock</div>
                <div className="cell combined-cells-3">
                  <InputData
                    tabIndex={51}
                    type="type-integer"
                    inactive={!toggleOptions.minStock}
                    size={0}
                    input={inputs.minStock}
                    onChange={(e) => {
                      handleInputChange("minStock", e);
                    }}
                  ></InputData>
                </div>
                <div className="combined-cells-4"></div>
                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Stock a cero</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("zeroStock")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.zeroStock}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">Stock</div>
                <div className="cell combined-cells-3">
                  <InputData
                    tabIndex={51}
                    type="type-integer"
                    size={0}
                    inactive={true}
                    input={0}
                    onChange={() => {
                      handleInputChange("zeroStock", 0);
                    }}
                  ></InputData>
                </div>
                <div className="combined-cells-4"></div>

                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Comisión por venta</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("saleComission")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.saleComission}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">% Comisión</div>
                <div className="cell combined-cells-3">
                  <InputData
                    tabIndex={52}
                    type="type-float2"
                    inactive={!toggleOptions.saleComission}
                    size={0}
                    input={inputs.saleComission}
                    onChange={(e) => {
                      handleInputChange("saleComission", e);
                    }}
                  ></InputData>
                </div>
              </div>
            </div>
            <div className="flex-col-gap">
              <div className="opt-table-content grid-4" id="bulk-edit-grid">
                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Descuento máximo</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("maxDiscount")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.maxDiscount}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">% Descuento</div>
                <div className="cell combined-cells-3">
                  <InputData
                    tabIndex={53}
                    size={0}
                    type="type-float2"
                    inactive={!toggleOptions.maxDiscount}
                    input={inputs.maxDiscount}
                    onChange={(e) => {
                      handleInputChange("maxDiscount", e);
                    }}
                  ></InputData>
                </div>
                <div className="cell"></div>
                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Nuevo PVP</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("valuePVP")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.valuePVP}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">Acción</div>
                <div className="cell combined-cells-3">
                  <Dropdown
                    tabIndex={54}
                    disabled={!toggleOptions.valuePVP}
                    optionList={[
                      { id: "", text: "" },
                      { id: "NuevoPVP", text: "NUEVO PVP" },
                      { id: "Porcentaje", text: "APLICAR %" },
                      { id: "SumarRestar", text: "SUMAR/RESTAR CANTIDAD" },
                    ]}
                    size={0}
                    op={actionPVP}
                    onChange={(e) => {
                      setActionPVP(e.id);
                    }}
                  ></Dropdown>
                </div>
                <div className="cell cell-start-content">Valor</div>
                <div className="cell combined-cells-3">
                  <InputData
                    tabIndex={55}
                    type="type-float2"
                    inactive={!toggleOptions.valuePVP}
                    size={0}
                    input={inputs.valuePVP}
                    onChange={(e) => {
                      handleInputChange("valuePVP", e);
                    }}
                  ></InputData>
                </div>
                <div className="combined-cells-4"></div>
                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Fecha límite</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("deadlineDate")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.deadlineDate}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">Fecha</div>
                <div className="cell combined-cells-3">
                  <input
                    type="datetime-local"
                    max="9999-12-31T23:59"
                    tabIndex={56}
                    step={1}
                    disabled={!toggleOptions.deadlineDate}
                    className="input-field w-180"
                    value={inputs.deadlineDate}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleInputChange(
                        "deadlineDate",
                        value === ""
                          ? ""
                          : moment(value).format("YYYY-MM-DD HH:mm:ss"),
                      );
                    }}
                    onKeyUp={(e) => inputOnEnter(e)}
                  ></input>
                </div>
                <div className="combined-cells-4"></div>

                <div className="combined-cells-4 opt-table-title cell-sb-content">
                  <span>Activar oferta</span>
                  <div
                    className="btn-sel"
                    onClick={() => handleToggle("activeOffer")}
                  >
                    <span className="cell-label">Seleccionar</span>
                    <CheckBox
                      tabIndex={-1}
                      active={toggleOptions.activeOffer}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                </div>
                <div className="cell cell-start-content">Fecha desde</div>
                <div className="cell combined-cells-3">
                  <input
                    type="datetime-local"
                    max="9999-12-31T23:59"
                    tabIndex={57}
                    disabled={!toggleOptions.activeOffer}
                    className="input-field w-180"
                    value={inputs.activateOfferDateFrom}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleInputChange(
                        "activateOfferDateFrom",
                        value === ""
                          ? ""
                          : moment(value).format("YYYY-MM-DD HH:mm:ss"),
                      );
                    }}
                    onKeyUp={(e) => inputOnEnter(e)}
                  ></input>
                </div>
                <div className="cell cell-start-content">Fecha hasta</div>
                <div className="cell combined-cells-3">
                  <input
                    type="datetime-local"
                    max="9999-12-31T23:59"
                    tabIndex={58}
                    disabled={!toggleOptions.activeOffer}
                    className="input-field w-180"
                    value={inputs.activateOfferDateTo}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleInputChange(
                        "activateOfferDateTo",
                        value === ""
                          ? ""
                          : moment(value).format("YYYY-MM-DD HH:mm:ss"),
                      );
                    }}
                    onKeyUp={(e) => inputOnEnter(e)}
                  ></input>
                </div>
                <div className="cell cell-start-content">Acción</div>
                <div className="cell combined-cells-3">
                  <Dropdown
                    tabIndex={59}
                    disabled={!toggleOptions.activeOffer}
                    optionList={[
                      { id: "", text: "" },
                      { id: "NuevoPVP", text: "NUEVO PVP" },
                      { id: "Descuento", text: "APLICAR % DESCUENTO" },
                      { id: "Restar", text: "RESTAR CANTIDAD" },
                    ]}
                    size={0}
                    op={actionActivationOffer}
                    onChange={(e) => {
                      setActionActivationOffer(e.id);
                    }}
                  ></Dropdown>
                </div>
                <div className="cell cell-start-content">Valor</div>
                <div className="cell combined-cells-3">
                  <InputData
                    tabIndex={60}
                    type="type-float2"
                    size={0}
                    inactive={!toggleOptions.activeOffer}
                    input={inputs.activateOfferValue}
                    onChange={(e) => {
                      handleInputChange("activateOfferValue", e);
                    }}
                  ></InputData>
                </div>
              </div>
            </div>
            <div className="flex-col-gap" style={{ flex: 1 }}>
              <div className="flex-col">
                <span className="opt-table-title">Ópticas</span>
                <div className="section-content-data">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "5px",
                      justifyContent: "flex-end",
                      padding: "0 10px 0 0",
                    }}
                  >
                    <button
                      className="cell-label"
                      onClick={handleSelectAllOptic}
                      tabIndex={-1}
                    >
                      Seleccionar todos
                    </button>
                    |
                    <button
                      className="cell-label"
                      onClick={handleCleanSelectedOptic}
                    >
                      Limpiar selección
                    </button>
                  </div>
                  <DataTable
                    columns={updatedOpticColumns}
                    data={opticList}
                    className="custom-datatable"
                    noDataComponent="No hay ópticas disponibles."
                    onRowClicked={(row) => {
                      handleCheckboxChangeOptic(row);
                    }}
                  />
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      gap: "20px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ButtonIconH
                      text="Aplicar"
                      small={true}
                      disabled={
                        !Object.values(toggleOptions).some(Boolean) ||
                        selectedOptics.length === 0
                      }
                      onClick={async () => {
                        await handleBulkEdition();
                        await getUpdatedProducts();
                      }}
                    ></ButtonIconH>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="suppliers-container sec-no-ov-y">
            <div
              className="supplier-container supplier-container-full"
              style={{ position: "relative" }}
            >
              <span className="opt-table-title">
                Listado de productos ({formatValueUnit(productList.length)})
              </span>
              <div className="suppliers-table flex-col">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    justifyContent: "flex-end",
                    padding: "0 10px 10px 0",
                  }}
                >
                  <button
                    className="cell-label"
                    onClick={handleSelectAll}
                    tabIndex={-1}
                  >
                    Seleccionar todos
                  </button>
                  |
                  <button
                    className="cell-label"
                    onClick={handleCleanSelected}
                    tabIndex={-1}
                  >
                    Limpiar selección
                  </button>
                </div>
                <DataTable
                  columns={selectProductFamilyColumns()}
                  data={productList}
                  className="custom-datatable"
                  noDataComponent="No hay productos disponibles."
                  onRowClicked={(row) => {
                    handleCheckboxChange(row);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
